import { createFileRoute } from '@tanstack/react-router';
import { OnboardingPage } from '@/features/creators/onboarding/onboarding-page';
import { seo } from '@/utils/seo';

// /ixi-finance/creators/onboarding — the creator onboarding form. Behind
// `_auth`: the landing page's join CTAs sign the creator in first (in place),
// and a direct visit gets the login funnel from the `_auth` gate. Not indexed.
export const Route = createFileRoute('/_auth/ixi-finance/creators_/onboarding')(
	{
		head: () => ({
			meta: seo({
				title: 'Become an ixiCreator — ixigo Creators',
				description: 'Join ixigo Creators and claim your creator code.',
			}),
		}),
		component: OnboardingPage,
		ssr: false,
	},
);
